module.exports = __webpack_public_path__ + "static/media/double-dice.99e88007.png";